const RESULT_EVENT = "acai-native-alarm-result";

export const nativeAlarmAvailable = () => Boolean(
  window.webkit?.messageHandlers?.acaiAlarm?.postMessage,
);

const requestId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `alarm-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const syncNativeMorningAlarm = (preferences) => {
  if (!nativeAlarmAvailable()) return Promise.resolve(null);

  const id = requestId();
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      window.removeEventListener(RESULT_EVENT, onResult);
      reject(new Error("iPhonen herätys ei vastannut ajoissa."));
    }, 15000);

    function onResult(event) {
      if (event.detail?.request_id !== id) return;
      window.clearTimeout(timeout);
      window.removeEventListener(RESULT_EVENT, onResult);
      if (event.detail.success) resolve(event.detail);
      else reject(new Error(event.detail?.message || "Herätyksen asettaminen ei onnistunut."));
    }

    window.addEventListener(RESULT_EVENT, onResult);
    window.webkit.messageHandlers.acaiAlarm.postMessage({
      action: preferences.enabled ? "schedule" : "cancel",
      request_id: id,
      wake_time: preferences.wake_time,
      weekdays: preferences.weekdays,
    });
  });
};
